export class RegistrationRequest {
  public Nome : string = '';
  public Cognome : string = '';
  public DataNascita : Date = new Date();
  public LuogoNascita : string = '';
  public CodiceFiscale : string = '';
  public IndirizzoResidenza : string = '';
  public Telefono : string = '';
  public Email : string = '';
  public confirmEmail : string = '';
  public Password : string = '';
  public confirmPassword : string = '';
  public privacyCheck : boolean | null = null;
  public Sesso : string = "";
  public IdComuneNascita : number = 0;
  public IdComuneResidenza : number = 0;
  public Cellulare : string = '';
  public AccettoInvioEmailFlag : boolean | null = null;
  public MansioniPreferenzeList : string = '';
}

export class ConfirmEmailViewModel {
  public Code : string = "";
  public UserId : string = "";
}
